export const bubbleSort = (arr: Object[], param: String, fromSmall: Boolean) => {

  if (!param) return arr

  for (let i = 0; i < arr.length - 1; i++) {
    for (let j = 0; j < arr.length - 1 - i; j++) {
      let el = arr[j]
      let nextEl = arr[j+1]
      let paramValLeft = parseFloat(el[param].split(/\s/).join(''));
      let paramValRight = parseFloat(nextEl[param].split(/\s/).join(''));


      if (fromSmall) {
        if (paramValLeft > paramValRight) {
          let t = arr[j+1];
          arr[j+1] = arr[j];
          arr[j] = t
        }
      } else {
        if (paramValLeft < paramValRight) {
          let t = arr[j+1];
          arr[j+1] = arr[j];
          arr[j] = t
        }
      }
      
    }
  }
  return arr
} 